import { Injectable } from '@angular/core';
import { ConfirmResponse } from '@app/models';
import { DriverDto, DriverShareRequest } from '@app/models/driver.model';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class DriversApi extends ApiService {
  static driversPrefix = '/driver';

  public getDrivers$(): Observable<DriverDto[]> {
    return this.get(`${DriversApi.driversPrefix}/list`, true);
  }

  public createDriver$(driver: DriverDto): Observable<DriverDto> {
    return this.post(DriversApi.driversPrefix, driver);
  }

  public updateDriver$(id: number, driver: DriverDto): Observable<DriverDto> {
    return this.put(`${DriversApi.driversPrefix}/${id}`, driver);
  }

  public removeDriver$(id: number): Observable<ConfirmResponse> {
    return this.delete(`${DriversApi.driversPrefix}/${id}`);
  }

  public shareDriver$(body: DriverShareRequest): Observable<DriverDto> {
    return this.post(`${DriversApi.driversPrefix}/share`, body);
  }

  public unshareDriver$(id: number): Observable<DriverDto> {
    return this.post(`${DriversApi.driversPrefix}/unshare/${id}`);
  }

  public getDriverPin$(driverId: number): Observable<DriverDto> {
    return this.get<DriverDto>(
      `${DriversApi.driversPrefix}/${driverId}/pin`,
      false,
    );
  }

  public generateDriverPin$(id: number): Observable<DriverDto> {
    return this.post(`${DriversApi.driversPrefix}/generate/pin/${id}`);
  }
}
